import { createAnalytics } from '@philo/segment-wrapper';
import { INTEGRATIONS } from '../web-shared/utils/segment';
import { isDoNotSellEnabled, lazyLoadPixel } from './pixel';

// LB: when updating this value please update https://www.notion.so/philoinc/Analytics-Version-Updates-ead146dd096243fa85e6a3f33259b298
// to reflect the reason for the change
const ANALYTICS_VERSION = 10;

export const ANALYTICS_ENVIRONMENT = {
  analyticsVersion: ANALYTICS_VERSION,
  namespace: 'web.login',
};

let KEY = 'tGHnd3KkkqdydDRosczE1Ai2eNJQN3ot';
if (process.env.NODE_ENV === 'development') {
  KEY = 'JelY4OKBPfi39d9OsXl0cieH0Zri4Xxz';
}

export function injectAnalytics(defer?: boolean) {
  createAnalytics(
    KEY,
    {
      // DT: Qualaroo is not used on login, and causes a major issue for TVE iOS
      // app Webview (click positions are very incorrect). See OTT-213
      integrations: {
        Qualaroo: false,
        ...(isDoNotSellEnabled() &&
          INTEGRATIONS.reduce((acc, integration) => ({ ...acc, [integration]: false }), {})),
      },
    },
    window,
    defer,
  );
}

export const loadAnalytics = () => lazyLoadPixel(() => analytics.load(KEY));
